'use client';
import { useRouter } from 'next/navigation';

import Cookies from 'universal-cookie';

import CookieName from './name';
import setCookie from '.';

export function useSetCookieAndRefresh() {
  const cookies = new Cookies();
  const router = useRouter();
  // Get a snapshot of current cookies using public API
  const current = Object.fromEntries(
    Object.entries(cookies.getAll() as Record<string, string>)
  );

  cookies.addChangeListener(() => {
    // find out what cookies have changed
    const changed = Object.keys(cookies.getAll() as Record<string, string>)
      .filter(key => {
        return current[key] !== cookies.get(key);
      })
      .filter(key => Object.values(CookieName)?.includes(key as CookieName));

    // only refresh if it's a cookie we care about
    if (changed.length) router.refresh();
  });

  return (name: CookieName, token?: string | null) => {
    setCookie(name, token);
    router.refresh();
  };
}

export default useSetCookieAndRefresh;
